import * as Yup from 'yup';
import {
  INSTANCE_PHONE_REG_EX,
  INSTANCE_PHONE_MIN_LENGTH,
} from '../utils/instanceConstant';

export const getProfileDetailsInitialValues = (user) => {
  return {
    firstName: user?.firstName || '',
    email: user?.email || '',
    positionTitle: user?.positionTitle || '',
    surname: user?.surname || '',
    phone: user?.phone || '',
    department: user?.department?.hierarchy?.label || '',
  };
};

export const profileDetailsValidationSchema = (t) =>
  Yup.object().shape({
    firstName: Yup.string().required(
      t('formulary.validation.first_name_required')
    ),
    email: Yup.string().required(t('formulary.validation.email_required')),
    positionTitle: Yup.string(),
    surname: Yup.string().required(t('formulary.validation.surname_required')),
    phone: Yup.string()
      .required(t('formulary.validation.phone_number_required'))
      .matches(
        INSTANCE_PHONE_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      )
      .min(
        INSTANCE_PHONE_MIN_LENGTH,
        t('formulary.validation.must_be_a_minimum_of_digits', {
          count: INSTANCE_PHONE_MIN_LENGTH,
        })
      ),
  });
